import * as url from "../helpers/url_helper";

/**
 * USE_MOCK=false(全真後端)時的「未串接守衛」。
 *
 * 8/10 與 8/12 兩次「紅海」的正解:未遷移模組的舊端點(url.DCK.*)在正式模式
 * 不該對真後端亂槍打鳥(CORS 噪音+preflight 500),更不該讓畫面顯示「網路連線
 * 異常」說謊 —— 應該**不出網、快速失敗、誠實說明**。
 *
 * 作法:對每個 mock 時代端點註冊 501 Not Implemented,轉譯層(errorMessages)
 * 對 501 顯示「此功能尚未串接正式後端」。已遷移的 /api-backend/* 不在此列,
 * 照常放行到真後端。隨模組逐一遷移(ticket 12),對應端點自然改走真路徑,
 * 這裡不用逐條移除。
 */
export default function registerNotImplementedGuards(mock) {
  Object.values(url.DCK).forEach((base) => {
    mock.onAny(new RegExp(`^${base}(/|\\?|$)`)).reply(501, "");
  });
}
